import React from "react";
import PageLayout from "./PageLayout";
import ShopSection from "./ShopSection";
import ShopPromoBanner from "./ShopPromoBanner";
import usePageMeta from "../hooks/usePageMeta";

const ShopPage = () => {
  usePageMeta({
    title: "Tienda | Hardware y accesorios | RG Servicio Técnico",
    description:
      "Explorá notebooks, periféricos, placas de video y más. Filtrá y elegí el hardware ideal con asesoramiento técnico.",
    canonical: "https://rgserviciotecnico.com/tienda"
  });
  return (
    <PageLayout className="bg-background">
      <ShopPromoBanner />
      <ShopSection headingLevel="h1" />
    </PageLayout>
  );
};

export default ShopPage;
